import React, { createContext, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAuth } from "../../../context/AuthContext";
import { authService } from "../../../services/authService";
import { getDefaultHomePath } from "../../../lib/screenAccess";
import { LoginFormData } from "../../../lib/validations";

interface LoginContextData {
  loading: boolean;
  handleLogin: (data: LoginFormData) => Promise<void>;
}

const LoginContext = createContext<LoginContextData>({} as LoginContextData);

export const LoginProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (data: LoginFormData) => {
    setLoading(true);
    try {
      const response = await authService.login({
        email: data.email,
        password: data.password,
      });
      login(response.access_token, response.user);

      navigate(getDefaultHomePath(response.user));
    } catch {
      toast.error("Credenciais inválidas. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <LoginContext.Provider value={{ loading, handleLogin }}>
      {children}
    </LoginContext.Provider>
  );
};

export const useLogin = () => {
  const context = useContext(LoginContext);
  if (!context) {
    throw new Error("useLogin deve ser usado dentro de LoginProvider");
  }
  return context;
};
